export default {
  path: '/user/groups',
  component: () => import('../layouts/Dashboard/Index.vue'),
  children: [
    {
      path: '',
      name: 'user groups',
      component: () => import('../views/UserGroups/PageList.vue'),
    },
    {
      path: '/user/group/:groupId',
      component: () => import('../views/UserGroups/Show/PageShow.vue'),
      children: [
        {
          path: 'summary',
          name: 'user group show summary',
          component: () =>
            import('../views/UserGroups/Show/Summary/PageSummary.vue'),
        },
        {
          path: 'members',
          name: 'user group show members',
          component: () => import('../views/UserGroups/Show/PageMembers.vue'),
        },
      ],
    },
  ],
}
